(() => {
  const counts = [50, 100, 150, 300];
  const parse = value => String(value).replace(/pieces/gi, '').trim().split(/\s*\+\s*/).map(Number);
  const title = sizes => `${new Set(sizes).size === 1 ? sizes[0] : sizes.join(' + ')} pieces`;
  const resolve = (variants, sizes) => variants.find(variant => variant.title === title(sizes));
  const detail = (stories, sizes) => stories.map((story, index) => `${story.title}: ${sizes[index]} pieces`).join('; ');
  globalThis.WonderPieces = { counts, parse, title, resolve, detail };
  if (typeof customElements === 'undefined' || customElements.get('wonder-bundle-pieces')) return;

  class BundlePieces extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.config = JSON.parse(this.querySelector('[data-wm-config]').textContent);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.open = false;
      this.stories = this.config.stories.slice(0, this.config.pack === 'pair' ? 2 : 3);
      this.sizes = this.stories.map(() => 50);
      this.scope = this.closest('[data-wg-purchase]') || this.closest('.shopify-section');
      this.native = this.dataset.mode === 'native';
      this.panel = this.querySelector('[data-wm-panel]');
      this.opener = this.querySelector('[data-wm-open]');
      this.rows = this.querySelector('[data-wm-rows]');
      this.hidden = !this.config.variants.some(variant => variant.title.includes(' + '));
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-wm-open')) this.open = true;
        if (button.hasAttribute('data-wm-reset')) {
          this.open = false;
          this.sizes = this.stories.map(() => this.sizes[0]);
        }
        if (button.dataset.wmSize) this.sizes[Number(button.dataset.wmRow)] = Number(button.dataset.wmSize);
        const focusSize = button.dataset.wmSize;
        const focusRow = button.dataset.wmRow;
        this.render();
        this.commit();
        if (focusSize) this.querySelector(`[data-wm-row="${focusRow}"][data-wm-size="${focusSize}"]`)?.focus({ preventScroll: true });
      }, options);
      if (this.native) {
        this.scope.classList.add('wm-native-scope');
        this.scope.addEventListener('change', event => {
          if (event.target.matches('input[data-option-name="Pieces"]') && !this.applying) {
            const values = parse(event.target.value);
            this.open = values.length > 1;
            this.sizes = values.length > 1 ? values : this.stories.map(() => values[0]);
          }
          this.readNativeStories();
          this.render();
          this.writeProperties();
        }, options);
        const input = this.scope.querySelector('variant-picker input[data-option-name="Pieces"]:checked');
        const values = parse(input?.value || '50 pieces');
        this.open = values.length > 1;
        this.sizes = values.length > 1 ? values : this.stories.map(() => values[0]);
        this.readNativeStories();
        this.writeProperties();
      }
      this.render();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    readNativeStories() {
      if (this.config.pack !== 'pair') return;
      const value = this.scope.querySelector('input[name="properties[Selected stories]"]:checked')?.value;
      if (!value) return;
      const normalize = text => text.replace(/[’‘]/g, "'").toLowerCase().trim();
      const selected = value.split(' + ').map(name => this.config.stories.find(story => normalize(story.title) === normalize(name)));
      if (selected.length === 2 && selected.every(Boolean)) this.stories = selected;
    }

    setStories(stories, uniformSize, selectedCounts, mixed) {
      this.stories = stories;
      this.sizes = stories.map((story, index) => selectedCounts?.[index] || uniformSize);
      this.open = Boolean(mixed);
      this.render();
    }

    render() {
      this.opener.hidden = this.open;
      this.panel.hidden = !this.open;
      this.opener.setAttribute('aria-expanded', String(this.open));
      if (this.native) this.scope.classList.toggle('wm-native-open', this.open);
      else this.scope.querySelector('.wg-size-field')?.classList.toggle('wm-uniform-hidden', this.open);
      this.rows.replaceChildren();
      this.stories.forEach((story, index) => {
        const row = document.createElement('div');
        row.className = 'wm-row';
        const name = document.createElement('span');
        name.className = 'wm-name';
        name.textContent = story.title;
        const group = document.createElement('div');
        group.className = 'wm-options';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', `${story.title} piece count`);
        counts.forEach(size => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = size;
          button.dataset.wmSize = size;
          button.dataset.wmRow = index;
          button.setAttribute('aria-pressed', String(this.sizes[index] === size));
          button.setAttribute('aria-label', `${size} pieces`);
          const next = this.sizes.map((value, slot) => slot === index ? size : value);
          button.disabled = !resolve(this.config.variants, next)?.available;
          group.append(button);
        });
        row.append(name, group);
        this.rows.append(row);
      });
    }

    commit() {
      if (!this.native) {
        this.dispatchEvent(new CustomEvent('wonder:pieces-change', { bubbles: true, detail: { mixed: this.open, sizes: [...this.sizes] } }));
        return;
      }
      const variant = resolve(this.config.variants, this.sizes);
      if (!variant?.available) return;
      const input = [...this.scope.querySelectorAll('variant-picker input[data-option-name="Pieces"]')].find(node => node.value === variant.title);
      if (input && !input.checked) {
        this.applying = true;
        input.click();
        this.applying = false;
      }
      this.writeProperties();
    }

    writeProperties() {
      const form = this.scope.querySelector('product-form-component form');
      if (!form) return;
      const value = this.open ? detail(this.stories, this.sizes) : '';
      let input = form.querySelector('[data-wm-property]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Piece counts]';
        input.dataset.wmProperty = '';
        form.append(input);
      }
      input.value = value;
      input.disabled = !this.open;
    }
  }
  customElements.define('wonder-bundle-pieces', BundlePieces);
})();
